<script>
    import { ISSUE_PRIORITY } from '@/constants';
    import CloseButton from '@/components/Modals/CloseButton.vue';

    export default {
        name: 'IssueItemModal',
        components: {
            CloseButton,
        },
        props: {
            item: {
                type: Object,
                required: true,
            },
            users: {
                type: Object,
                required: false,
                default: null,
            },
        },
        methods: {
            modalClosed() {
                this.$emit('close');
            },
        },
        computed: {
            assignees() {
                if (
                    !this.item.params.assignees
                    || !this.item.params.assignees.users
                    || !this.users
                ) { return false; }

                return this.item.params.assignees.users
                    .map((user) => this.users[user])
                    .join(', ');
            },
            priority() {
                return {
                    [ISSUE_PRIORITY.LOW]: {
                        text: this.$t('Low'),
                        class: 'badge--blue',
                    },
                    [ISSUE_PRIORITY.MEDIUM]: {
                        text: this.$t('Medium'),
                        class: 'badge--yellow',
                    },
                    [ISSUE_PRIORITY.HIGH]: {
                        text: this.$t('High'),
                        class: 'badge--red',
                    },
                }[this.item.params.priority];
            },
            dueIn() {
                if (!this.item.params.due_in) return this.$t('No due in date provided');

                const lookup = {
                    weeks: this.$t('Week(s)'),
                    days: this.$t('Days(s)'),
                    hours: this.$t('Hours(s)'),
                    minutes: this.$t('Min(s)'),
                };
                const dueIn = this.item.params.due_in;

                const result = Object.entries(dueIn).reduce((acc, [label, value]) => {
                    if (!label || !value || value <= 0) return acc;
                    acc.push(`${value} ${lookup[label]}`);
                    return acc;
                }, []);

                return result.join(', ');
            },
        },
    };
</script>

<template>
    <modal @modal-close="modalClosed">
        <div class="modal-wrapper">
            <CloseButton @click="modalClosed" />

            <div class="modal-content">
                <div class="item">
                    <h4>{{ $t('Title') }}</h4>
                    <p>{{ item.params.title }}</p>
                </div>

                <div class="item" v-if="item.params.description">
                    <h4>{{ $t('Description') }}</h4>
                    <p>{{ item.params.description }}</p>
                </div>

                <div class="item" v-if="assignees">
                    <h4>{{ $t('Assignees') }}</h4>
                    <p>{{ assignees }}</p>
                </div>

                <div class="item">
                    <h4>{{ $t('Priority') }}</h4>
                    <p class="badge" :class="priority.class">
                        {{ priority.text }}
                    </p>
                </div>

                <div class="item" v-if="item.executed_at">
                    <h4>{{ $t('Issue was raised at') }}</h4>
                    <p>{{ $du(item.executed_at, 'shortDateTime') }}</p>
                </div>
                <div class="item" v-else-if="item.params.due_in">
                    <h4>{{ $t('Due after issue has been raised') }}</h4>
                    <p>{{ dueIn }}</p>
                </div>

                <div
                    class="item"
                    v-if="item.params.suggested_corrective_action"
                >
                    <h4>{{ $t('Suggested corrective action') }}</h4>
                    <p>{{ item.params.suggested_corrective_action }}</p>
                </div>
            </div>
        </div>
    </modal>
</template>
